module.exports = __webpack_public_path__ + "media/images/strokes-68d0da259b1dea11cc7a3287450edcd8.png";